import { isClient } from '@vueuse/core'
export class AppUtils {
  terminal?: 'ios' | 'android'
  jcAppMessageHandler?: any

  constructor() {
    let terminal: 'ios' | 'android' | undefined
    if (isClient) {
      if (window?.webkit?.messageHandlers?.jcAppMessageHandler) {
        terminal = 'ios'
      }
      if (window?.jcAppMessageHandler) {
        terminal = 'android'
      }

      this.terminal = terminal
      this.jcAppMessageHandler =
        window?.webkit?.messageHandlers?.jcAppMessageHandler ||
        window?.jcAppMessageHandler
    }
  }

  isApp: boolean =
    Boolean(
      window?.webkit?.messageHandlers?.jcAppMessageHandler?.postMessage,
    ) || Boolean(window?.jcAppMessageHandler?.postMessage)

  postMessage<T = any>(
    method: string,
    params?: Record<string, any>,
  ): Promise<T> {
    const name = `APP_CALLBACK_${method}`

    return new Promise((resolve, reject) => {
      try {
        if (this.terminal == 'ios') {
          ;(window as any)[name] = (res: string) => {
            resolve(JSON.parse(res))
            delete (window as any)[name]
          }
        }
        const messageData = JSON.stringify({
          method: method,
          callBack: name,
          params: params,
        })
        const proms = this.jcAppMessageHandler?.postMessage(messageData)
        if (this.terminal === 'android') {
          resolve(JSON.parse(proms || '{}'))
        }
      } catch (err) {
        console.error(err)
        reject(err)
      }
    })
  }

  // Return to the app
  backApp(): Promise<void> {
    return this.postMessage('goBack', {})
  }

  // Get app language
  getLang(): Promise<string> {
    return this.postMessage('lang', {})
  }
}
